var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrepare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.208 11.75H8V13H.958V.958h11.75V8h-1.25V2.208h-9.25v9.542Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15 10.334-6.417-1.75L10.333 15l1.167-2.333L13.833 15 15 13.834 12.667 11.5 15 10.334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrepare);
export default __webpack_public_path__ + "static/media/icon-prepare.bde2e96ff9a0660e4e0c7965ab6ca4ba.svg";
export { ForwardRef as ReactComponent };